import { render, staticRenderFns } from "./Quantidade.vue?vue&type=template&id=ba02ffca&scoped=true&"
import script from "./Quantidade.vue?vue&type=script&lang=js&"
export * from "./Quantidade.vue?vue&type=script&lang=js&"
import style0 from "./Quantidade.vue?vue&type=style&index=0&id=ba02ffca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba02ffca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
